var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import classNames from 'classnames';
import omit from 'lodash/omit';

import './SubmenuItem.scss';

var SUBMENU_LEFT_ALIGNED_CLASS = 'is-left-aligned';
var SUBMENU_BOTTOM_ALIGNED_CLASS = 'is-bottom-aligned';

/**
 * A menu-item component which triggers open a submenu
 *
 * @NOTE: Nested submenus are NOT currently supported, switching
 * focus with arrow keys in the subsubmenu is not working properly.
 */
var SubmenuItem = function (_React$Component) {
    _inherits(SubmenuItem, _React$Component);

    function SubmenuItem() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SubmenuItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubmenuItem.__proto__ || Object.getPrototypeOf(SubmenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isSubmenuOpen: false,
            submenuFocusIndex: null,
            submenuClasses: []
        }, _this.getMenuAlignmentClasses = function () {
            var _ref2;

            if (!_this.submenuTriggerEl || !_this.submenuEl) {
                return {};
            }

            var _this$props = _this.props,
                rightBoundaryElement = _this$props.rightBoundaryElement,
                bottomBoundaryElement = _this$props.bottomBoundaryElement;

            var submenuElBounding = _this.submenuEl.getBoundingClientRect();
            // $FlowFixMe checked this.submenuEl is set above
            var submenuTriggerElBounding = _this.submenuTriggerEl.getBoundingClientRect();
            var rightBoundaryElementBounding = rightBoundaryElement ? rightBoundaryElement.getBoundingClientRect() : { right: window.innerWidth };
            var bottomBoundaryElementBounding = bottomBoundaryElement ? bottomBoundaryElement.getBoundingClientRect() : { bottom: window.innerHeight };

            var isLeftAligned = submenuTriggerElBounding.right + submenuElBounding.width > rightBoundaryElementBounding.right;
            var isBottomAligned = submenuTriggerElBounding.top + submenuElBounding.height > bottomBoundaryElementBounding.bottom;

            return _ref2 = {}, _defineProperty(_ref2, SUBMENU_LEFT_ALIGNED_CLASS, isLeftAligned), _defineProperty(_ref2, SUBMENU_BOTTOM_ALIGNED_CLASS, isBottomAligned), _ref2;
        }, _this.handleMenuItemClick = function (event) {
            var _this$props2 = _this.props,
                isDisabled = _this$props2.isDisabled,
                onClick = _this$props2.onClick;

            // If aria-disabled is passed as a prop, we should ignore clicks on this menu item

            if (isDisabled) {
                event.stopPropagation();
                event.preventDefault();

                return;
            }

            if (onClick) {
                onClick(event);
            }
        }, _this.handleKeyDown = function (event) {
            switch (event.key) {
                case ' ': // Spacebar
                case 'Enter':
                case 'ArrowRight':
                    event.stopPropagation();
                    event.preventDefault();

                    _this.openSubmenuAndFocus();
                    break;
                default:
                    break;
            }
        }, _this.closeSubmenu = function () {
            _this.setState({
                isSubmenuOpen: false
            });
        }, _this.closeSubmenuAndFocusTrigger = function (isKeyboardEvent) {
            _this.closeSubmenu();

            if (_this.submenuTriggerEl && isKeyboardEvent) {
                _this.submenuTriggerEl.focus();
            }
        }, _this.openSubmenu = function () {
            _this.setState({
                isSubmenuOpen: true,
                submenuFocusIndex: null
            });
        }, _this.openSubmenuAndFocus = function () {
            _this.setState({
                isSubmenuOpen: true,
                submenuFocusIndex: 0
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SubmenuItem, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                isDisabled = _props.isDisabled,
                rest = _objectWithoutProperties(_props, ['children', 'className', 'isDisabled']);

            var _state = this.state,
                isSubmenuOpen = _state.isSubmenuOpen,
                submenuFocusIndex = _state.submenuFocusIndex;


            var elements = React.Children.toArray(children);
            var submenuTriggerContent = elements[0];
            var submenu = elements[1];
            if (elements.length !== 2 || !submenuTriggerContent || !submenu) {
                throw new Error('SubmenuItem must have exactly two children, a trigger component and a <Menu>');
            }

            var menuItemProps = _extends({}, omit(rest, ['bottomBoundaryElement', 'onClick', 'rightBoundaryElement', 'role', 'tabIndex']), {
                'aria-disabled': isDisabled ? 'true' : undefined,
                'aria-expanded': isSubmenuOpen ? 'true' : 'false',
                'aria-haspopup': 'true',
                className: classNames('menu-item', 'submenu-target', className),
                onClick: this.handleMenuItemClick,
                onMouseLeave: this.closeSubmenu,
                onMouseEnter: this.openSubmenu,
                onKeyDown: this.handleKeyDown,
                ref: function ref(_ref3) {
                    _this2.submenuTriggerEl = _ref3;
                },
                role: 'menuitem',
                tabIndex: -1
            });

            var submenuProps = {
                className: classNames(submenu.props.className, 'submenu', this.getMenuAlignmentClasses()),
                initialFocusIndex: submenuFocusIndex,
                // Hide the menu instead of unmounting it. Otherwise onMouseLeave won't work.
                isHidden: !isSubmenuOpen,
                isSubmenu: true,
                onClose: this.closeSubmenuAndFocusTrigger,
                setRef: function setRef(ref) {
                    _this2.submenuEl = ref;
                }
            };

            return React.createElement(
                'li',
                menuItemProps,
                submenuTriggerContent,
                React.cloneElement(submenu, submenuProps)
            );
        }
    }]);

    return SubmenuItem;
}(React.Component);

SubmenuItem.propTypes = {
    /** An HTMLElement defining the bottom boundary for the submenu */
    bottomBoundaryElement: function bottomBoundaryElement() {
        return (typeof HTMLElement === 'function' ? PropTypes.instanceOf(HTMLElement) : PropTypes.any).apply(this, arguments);
    },
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,

    /** An HTMLElement defining the right boundary for the submenu */
    rightBoundaryElement: function rightBoundaryElement() {
        return (typeof HTMLElement === 'function' ? PropTypes.instanceOf(HTMLElement) : PropTypes.any).apply(this, arguments);
    }
};


export default SubmenuItem;
import PropTypes from 'prop-types';